<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="title-heading d-flex justify-content-between">
          <h1>{{ $static('dashboard.title', 'Панелі') }}</h1>
        </div>

        <div class="row dashboard-row">
          <div class="col-12 ">
            <div class="panel">
              <div class="row" v-if="traffics.length">
                <div class="col-12">
                  <div class="panel panel-bordered">
                    <ul class="dashboard-stat-sourses">
                      <li v-for="t in traffics">
                        <div class="holder" v-if="!t.deleted">
                          <div class="count-holder" :title="'Всого: ' + t.count">
                            <span class="count" v-if="traffics_total[t.code]">{{ traffics_total[t.code] }}</span>
                            <span class="count" v-else>0</span>
                          </div>
                          <input type="text" :value="t.name" class="form-control custom-input"
                            @change="event => updateTraffic(event, t)">

                          <div class="dashboard-action-btns">
                            <Popper arrow :content="$static('db.web-btn', 'Веб-посилання')" hover placement="right"
                              style="white-space: nowrap">
                              <button v-if="isWeb" @click="getWebLink(t)" class="btn-icon btn-icon-outline">
                                <img src="/images/icons/www.svg">
                              </button>
                            </Popper>
                            <Popper arrow :content="$static('db.telegram-btn', 'Telegram')" hover placement="right"
                              style="white-space: nowrap">
                              <button v-if="isTelegram" @click="getTelegramLink(t)" class="btn-icon btn-icon-outline">
                                <span class="icon icon-telegram"></span>
                              </button>
                            </Popper>
                            <Popper arrow :content="$static('db.del', 'Видалити')" hover placement="right"
                              style="white-space: nowrap">
                              <button class="btn-icon btn-red" @click="delCode(t)">
                                <span class="icon icon-trash-filled"></span>
                              </button>
                            </Popper>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <a href="javascript:void(0)" class="default-link" @click="newCode" style="padding-left: 95px;">
                      <span class="text">{{ $static('dashboard.create-code', 'Створити код') }}</span><span
                        class="icon icon-add"></span>
                    </a>
                  </div>
                </div>
                <div class="col-12" style="min-height: 400px;">
                  <div style="height: 300px;position: relative;">
                    <DashboardTraffic :traffic="traffics" :traffic_log="log_traffics"></DashboardTraffic>
                  </div>
                  <!--                  <div class="col-6" style="height: 360px;">-->
                  <!--                    <DashboardTrafficLogs :traffic="traffics" :traffic_log="log_traffics"></DashboardTrafficLogs>-->
                  <!--                  </div>-->
                </div>
                <!--                <div class="col-8" v-else>-->
                <!--                  <h2 style="text-align: center">Недостатньо даних для графіків.</h2>-->
                <!--                </div>-->
              </div>
              <div class="row" v-else>
                <a href="javascript:void(0)" class="default-link" @click="newCode" style="margin: 0 auto; padding: 0">
                  <span class="text">{{ $static('dashboard.create-code', 'Створити код') }}</span><span
                    class="icon icon-add"></span>
                </a>
              </div>
            </div>

          </div>
        </div>

        <div class="row dashboard-row">
          <div class="col-4 dashboard-col">
            <div class="dashboard-item ">
              <div class="title d-flex align-items-center">
                <span class="icon-2 icon-2bel"></span>
                <h4>{{ $static('dashboard.t1', 'Нові замовлення') }}</h4>
              </div>
              <div class="value">
                <span class="text"> {{ info.new_count }}</span>
              </div>
            </div>
          </div>
          <div class="col-4 dashboard-col">
            <div class="dashboard-item ">
              <div class="title d-flex align-items-center">
                <span class="icon icon-shopping-basket"></span>
                <h4>{{ $static('dashboard.t2', 'Всього замовлень') }}</h4>
              </div>
              <div class="value">
                <span class="text"> {{ $filters.money(info.count) }}</span>
              </div>
            </div>
          </div>
          <div class="col-4 dashboard-col">
            <div class="dashboard-item ">
              <div class="title d-flex align-items-center">
                <span class="icon-2 icon-2wallet"></span>
                <h4>{{ $static('dashboard.t3', 'Загальний обсяг продажів') }}</h4>
              </div>
              <div class="value">
                <span class="text"> {{ $filters.money(info.total) }} <small>{{ $store.getters.symbol }}</small></span>
              </div>
            </div>
          </div>
          <div class="col-4 dashboard-col">
            <div class="dashboard-item ">
              <div class="title d-flex align-items-center">
                <span class="icon-2 icon-2layout"></span>
                <h4>{{ $static('dashboard.t4', 'Завантажені продукти') }}</h4>
              </div>
              <div class="value">
                <span class="text"> {{ $filters.money(info.item_count) }}</span>
              </div>
            </div>
          </div>
          <div class="col-4 dashboard-col">
            <div class="dashboard-item ">
              <div class="title d-flex align-items-center">
                <span class="icon icon-telegram"></span>
                <h4>{{ $static('dashboard.t5', 'Передплатники телеграм-бота') }}</h4>
              </div>
              <div class="value">
                <span class="text"> {{ $filters.money(info.sub_count) }}</span>
              </div>
            </div>
          </div>
          <div class="col-4 dashboard-col">
            <div class="dashboard-item ">
              <div class="title d-flex align-items-center">
                <span class="icon icon-user"></span>
                <h4>{{ $static('dashboard.t6', 'Всього покупців') }}</h4>
              </div>
              <div class="value">
                <span class="text"> {{ info.buyers_count }}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import DashboardTraffic from '@/components/DashboardTraffic';

export default {
  name: 'AdminDashboard',
  components: {
    DashboardTraffic
    // FileManager
  },
  data() {
    return {
      info: {},
      traffics: [],
      log_traffics: [],
      traffics_total: {}
    }
  },
  computed: {
    headerINFO() {
      return this.$store.getters.info
    },
    isWeb() {
      return this.headerINFO.link !== undefined
    },
    isTelegram() {
      return this.headerINFO.BOT_NAME !== undefined
    }
  },
  methods: {
    updateTraffic(event, item) {
      item.name = event.target.value
      api.put('/api/dashboard/code', { list: [{ id: item.id, name: item.name }] })
    },
    getWebLink(t) {
      navigator.clipboard.writeText(`${this.headerINFO.link}?code=${t.code}`);
      this.$notify({
        title: this.$static('notify-copy.title', 'Копіювання'),
        text: this.$static('notify.copyed', 'Збережено у буфер'),
        duration: 3000
      });
    },
    getTelegramLink(t) {
      navigator.clipboard.writeText(`https://t.me/${this.headerINFO.BOT_NAME}?start=${t.code}`);
      this.$notify({
        title: this.$static('notify-copy.title', 'Копіювання'),
        text: this.$static('notify.copyed', 'Збережено у буфер'),
        duration: 3000
      });
    },
    newCode() {
      api.put('/api/dashboard/code', { list: [{ code: '' }] }).then(response => response.data)
        .then(x => {
          this.traffics.push(x[0])
          // console.log(x[0])
        })
    },
    delCode(t) {
      window.$('#confirm-modal').modal('show');
      window.onModalConfirm = () => {
        api.delete('/api/dashboard/code/' + t.id).then(response => response.data)
        let idx = this.traffics.findIndex(i => i.id === t.id);
        if (idx > -1) {
          this.traffics[idx].deleted = true
        }
        let check = this.traffics.find(x => x.deleted === undefined);
        if (!check) {
          this.fetchData();
        }
      }
    },
    getCodes() {
      return api.get('/api/dashboard/code').then(response => response.data).then(data => {
        if (data) {
          this.traffics = data
        }
        return data
      })
    },
    fetchData() {
      api.get('/api/dashboard').then(response => response.data).then(
        data => {
          if (data) {
            if (data.traffics) {
              this.traffics = data.traffics
              delete data.traffics
              this.log_traffics = data.traffics_log
              Object.keys(this.log_traffics).forEach(value => {
                this.traffics_total[value] = Object.values(data.traffics_log[value]).reduce((a, b) => {
                  // console.log(a, b)
                  return a + b;
                }, 0)
              })
              delete data.traffics_log
            }
            this.info = data
          }
        })
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>
